// extracted by mini-css-extract-plugin
module.exports = {"documentsContainer":"_03da320"};